const QueryKeys = {
  PendingRequest: "dashboard-requests",
  Advertisers: "dashboard-advertisers",
  Providers: "dashboard-providers",
  ProvidersPassive: "passive",
  ProvidersRegistered: "registered",
  RegisteredCompanies: "RegisteredCompanies",
} as const;

export default QueryKeys;

// https://stackoverflow.com/a/53662389
export type QueryKey = (typeof QueryKeys)[keyof typeof QueryKeys];
